import Vue from 'vue';
import equipmentTransformer from '../../transformers/equipment';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(equipmentTransformer.fetch(errors));
};

export default equipment => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/equipment', equipment)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/equipment/store.js